/**
 * OutcomesReportTile - Four Consumer Duty outcome scores, links to full report
 *
 * Atomic level: Molecule
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../../../ui/card';
import { getConductScoreColor } from './ConductScoreIndicator';

interface OutcomeRow {
  name: string;
  score: number;
}

interface OutcomesReportTileProps {
  collectionId: string;
  outcomes: OutcomeRow[];
  className?: string;
}

const OutcomesReportTile: React.FC<OutcomesReportTileProps> = ({
  collectionId,
  outcomes,
  className = '',
}) => {
  return (
    <Link to={`/v4/reports/outcome/${collectionId}`} className="block h-full">
      <Card
        className={`bg-white border-slate-200 cursor-pointer hover:border-primary/30 hover:shadow-sm transition-all h-full ${className}`}
      >
        <CardContent className="p-4 flex flex-col gap-3">
          <h3 className="text-[13px] font-bold">Outcomes Report</h3>

          <div className="flex flex-col gap-2">
            {outcomes.map((outcome) => {
              const color = getConductScoreColor(outcome.score);
              return (
                <div key={outcome.name} className="flex items-center gap-2">
                  <span
                    className="w-6 h-6 rounded-full flex items-center justify-center text-[8px] font-extrabold text-white shrink-0"
                    style={{ backgroundColor: color }}
                  >
                    {outcome.score.toFixed(1)}
                  </span>
                  <span className="text-[11px] font-semibold text-foreground">
                    {outcome.name}
                  </span>
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};

export { OutcomesReportTile };
export type { OutcomesReportTileProps };
